import { api, BASE_URL } from "../config";

const ADMIN_COMMERCIAL_CONTROL_URL = BASE_URL + "admin/commercial/";

export function listAdminCommercialPlans() {
    return api.get(ADMIN_COMMERCIAL_CONTROL_URL + "plans").then(res => res.data);
}

export function getAdminCommercialPlan(planId) {
    return api.get(ADMIN_COMMERCIAL_CONTROL_URL + `plans/${planId}`).then(res => res.data);
}

export function updateAdminCommercialPlan(planId, payload) {
    return api.patch(ADMIN_COMMERCIAL_CONTROL_URL + `plans/${planId}`, payload).then(res => res.data);
}

export function listAdminPlanCapabilities(planId) {
    return api.get(ADMIN_COMMERCIAL_CONTROL_URL + `plans/${planId}/capabilities`).then(res => res.data);
}

export function updateAdminPlanCapability(planId, capabilityKey, payload) {
    return api
        .patch(ADMIN_COMMERCIAL_CONTROL_URL + `plans/${planId}/capabilities/${capabilityKey}`, payload)
        .then(res => res.data);
}

export function listAdminPolicyMessages() {
    return api.get(ADMIN_COMMERCIAL_CONTROL_URL + "policy-messages").then(res => res.data);
}

export function getAdminPolicyMessage(code) {
    return api.get(ADMIN_COMMERCIAL_CONTROL_URL + `policy-messages/${code}`).then(res => res.data);
}

export function updateAdminPolicyMessage(code, payload) {
    return api.patch(ADMIN_COMMERCIAL_CONTROL_URL + `policy-messages/${code}`, payload).then(res => res.data);
}

export function getAdminWorkspaceSubscription(clientId) {
    return api.get(ADMIN_COMMERCIAL_CONTROL_URL + `workspaces/${clientId}/subscription`).then(res => res.data);
}

export function upsertAdminWorkspaceSubscription(clientId, payload) {
    return api.put(ADMIN_COMMERCIAL_CONTROL_URL + `workspaces/${clientId}/subscription`, payload).then(res => res.data);
}

export function getAdminWorkspaceUsage(clientId) {
    return api.get(ADMIN_COMMERCIAL_CONTROL_URL + `workspaces/${clientId}/usage`).then(res => res.data);
}

export function getAdminWorkspaceReservations(clientId, limit = 100) {
    return api
        .get(ADMIN_COMMERCIAL_CONTROL_URL + `workspaces/${clientId}/reservations`, { params: { limit } })
        .then(res => res.data);
}

export function getAdminWorkspaceUsageEvents(clientId, limit = 100) {
    return api
        .get(ADMIN_COMMERCIAL_CONTROL_URL + `workspaces/${clientId}/usage-events`, { params: { limit } })
        .then(res => res.data);
}

export function listAdminWorkspaceAdjustments(clientId, limit = 100) {
    return api
        .get(ADMIN_COMMERCIAL_CONTROL_URL + `workspaces/${clientId}/adjustments`, { params: { limit } })
        .then(res => res.data);
}

export function createAdminWorkspaceAdjustment(clientId, payload) {
    return api.post(ADMIN_COMMERCIAL_CONTROL_URL + `workspaces/${clientId}/adjustments`, payload).then(res => res.data);
}

export function revokeAdminUsageAdjustment(adjustmentId, payload) {
    return api.patch(ADMIN_COMMERCIAL_CONTROL_URL + `adjustments/${adjustmentId}/revoke`, payload).then(res => res.data);
}

export function releaseAdminReservation(reservationId, payload) {
    return api.patch(ADMIN_COMMERCIAL_CONTROL_URL + `reservations/${reservationId}/release`, payload).then(res => res.data);
}
